import React from 'react';
import { Helmet } from 'react-helmet';

import setWrappedComponent from '../utils/react/setWrappedComponent';

export default function withSearchIndex(WrappedComponent) {
  function WithSearchIndex(props) {
    return (
      <>
        <Helmet>
          <meta name="robots" content="all" />
        </Helmet>
        <WrappedComponent {...props} />
      </>
    );
  }

  setWrappedComponent(WithSearchIndex, WrappedComponent);

  return WithSearchIndex;
}
